import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// Used to catch any other errors - not server-side.

export var APIError = /*#__PURE__*/function (_Error) {
  _inherits(APIError, _Error);
  var _super = _createSuper(APIError);
  function APIError(kind, hostname, message, type) {
    var _this;
    _classCallCheck(this, APIError);
    _this = _super.call(this, "".concat(kind, ": ").concat(message));
    _this.kind = kind;
    _this.hostname = hostname;
    _this.message = message;
    _this.type = type;
    _this.name = 'APIError';
    // The error type received from the server.
    _this.type = type;
    // The kind mapped to on the client.
    _this.kind = kind;
    // The message received from the server.
    _this.message = message;
    // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
    _this.hostname = hostname;
    return _this;
  }
  return _createClass(APIError);
}( /*#__PURE__*/_wrapNativeSuper(Error));